let mutations = {
  RESTORE_TREASURY_STATES: (state) => {
    Object.assign(state, {});
  },
};

export default mutations;
